export default __webpack_public_path__ + "static/media/mark-white.19ba37dd.svg";